<template>
  <div class="actions">
    <ReviewBoosterTooltip
      v-if="userActions.phoneNumber"
      :text="userActions.phoneNumber"
    >
      <PhoneIcon />
    </ReviewBoosterTooltip>
    <ReviewBoosterTooltip
      v-if="showGoogleMapsClicked"
      :text="$t('message.reviewBooster.reviews.googleMapsClicked')"
    >
      <RbToGoogleIcon />
    </ReviewBoosterTooltip>
    <ReviewBoosterTooltip
      v-if="userActions.gmbReviewMatched && showReviewAddedToGoogleMaps"
      :text="
        $t('message.reviewBooster.reviews.googleMapsClickedAndReviewAdded')
      "
    >
      <RbToGoogleAndReviewIcon />
    </ReviewBoosterTooltip>
    <ReviewBoosterTooltip
      v-if="userActions.aiGenerated"
      :text="$t('message.reviewBooster.reviews.aiGenerated')"
    >
      <AiIcon />
    </ReviewBoosterTooltip>
    <ReviewBoosterTooltip v-if="userActions.email" :text="userActions.email">
      <EnvelopeIcon />
    </ReviewBoosterTooltip>
  </div>
</template>

<script>
import ReviewBoosterTooltip from "@/components/ReviewBooster/ReviewBoosterTooltip";

export default {
  name: "ReviewBoosterReviewUserActions",
  components: {
    PhoneIcon: () => import("@/components/ui/Icons/PhoneIcon"),
    RbToGoogleIcon: () => import("@/components/ui/Icons/RbToGoogleIcon.vue"),
    RbToGoogleAndReviewIcon: () =>
      import("@/components/ui/Icons/RbToGoogleAndReviewIcon.vue"),
    AiIcon: () => import("@/components/ui/Icons/AiIcon"),
    EnvelopeIcon: () => import("@/components/ui/Icons/EnvelopeIcon"),
    ReviewBoosterTooltip
  },
  inject: {
    showReviewAddedToGoogleMaps: {
      default: false
    }
  },
  props: {
    userActions: {
      type: Object
    }
  },
  computed: {
    isReviewAddedAndNotMatched() {
      return (
        this.userActions.googleMapsClicked &&
        !this.userActions.gmbReviewMatched &&
        this.showReviewAddedToGoogleMaps
      );
    },
    isReviewClickedAndNotAdded() {
      return (
        (this.userActions.gmbReviewMatched ||
          this.userActions.googleMapsClicked) &&
        !this.showReviewAddedToGoogleMaps
      );
    },
    showGoogleMapsClicked() {
      return this.isReviewAddedAndNotMatched || this.isReviewClickedAndNotAdded;
    }
  }
};
</script>

<style lang="scss" scoped>
.actions {
  display: flex;
  justify-content: space-between;
  gap: $spacing * 2;
}
</style>
